import { useIsClient } from "src/hooks/use-is-client";

type MobileOS = "ios" | "android";

const detectMobileOS = (): MobileOS | undefined => {
  const { userAgent, maxTouchPoints } = navigator;

  if (/android/i.test(userAgent)) {
    return "android";
  }

  if (
    /iPad|iPhone|iPod/.test(userAgent) ||
    (/Macintosh/.test(userAgent) && maxTouchPoints > 1)
  ) {
    return "ios";
  }

  return undefined;
};

function useMobileOS(): { mobileOS?: MobileOS; resolved: boolean } {
  const resolved = useIsClient();

  return {
    mobileOS: resolved ? detectMobileOS() : undefined,
    resolved,
  };
}

export { useMobileOS };
export type { MobileOS };
